export default __webpack_public_path__ + "static/media/quickCallBg.4313b7a6.png";